import React from 'react';

import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/schema';
import { AnalyticsCardProps } from '../cards/types';
import { InteractionModalAccordionsHook, InteractionModalComponentProps } from '../types';

import { VideoOverlayTypes } from '../InteractionInfo';
import { OverlayInteractionInfo } from '../OverlayInteractionInfo';
import { useTextOverlaySettings } from './useTextOverlaySettings';

const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));
const TextOverlayModal = React.lazy(() => import('./TextOverlayModal'));

export class TextOverlayInfo extends OverlayInteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    public attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public hasEndsAt(): boolean {
    return true;
  }

  public hasPinToTopToggle(): boolean {
    return false;
  }

  public hasVideoOverlay(): VideoOverlayTypes | null {
    return 'over-video';
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TextOverlayModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return useTextOverlaySettings;
  }
}
